import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import {submitCreateAttendanceReport} from '../../../api'
import ResidentCreateAttendanceReport from './residentCreateAttendanceReport.vue'

@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType: ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_ReloadData',
        model: "deli.aries.resident.business.DeliAriesResidentBusinessEmployeeProxy",
        widget: 'ClientAction',
    })
)
export class residentCreateAttendanceReport extends ReloadViewActionWidget {
    initialize(props: any) {
        super.initialize(props);
        this.setComponent(ResidentCreateAttendanceReport)
        return this;
    }


    @Widget.Method()
    async submitData(data: any) {
        await submitCreateAttendanceReport(this.model, {
            billPeriod: data,
            employeeId: (this.parentActiveRecords || []).map(n => n.id)
        });
    }

}
